<template>
  <div class="container-sm bg-gray-100 mb-5 p-2">
    <div class="flex justify-center">
      <loading
        :height="15"
        color="#fff"
        class="static"
        :active="isLoading"
        loader="dots"
        :can-cancel="true"
        :is-full-page="false"
      />
    </div>
    <div>
      <router-link
        type="button"
        class="hover:underline block text-left"
        to="/Quotation"
      >
        <svg
          class="h-8 w-8 fill-current text-blue-900"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="274.835 394.86 54.965 55.15"
        >
          <defs />
          <path
            d="M302.4 395.823c14.752.013 26.694 12.004 26.695 26.805.001 14.592-12.041 26.517-26.753 26.495-14.737-.023-26.754-11.98-26.684-26.551.072-14.873 11.958-26.763 26.742-26.749zm.342 32.534h2.447c3.522 0 7.044.033 10.565-.013 2.327-.03 3.413-1.138 3.479-3.442.039-1.364.033-2.731.003-4.096-.057-2.537-.978-3.536-3.514-3.605-2.801-.076-5.605-.022-8.408-.024-1.471-.001-2.942 0-4.571 0 0-1.899.247-3.457-.079-4.885-.254-1.114-1.01-2.527-1.934-2.949-.783-.357-2.422.2-3.171.899-3.518 3.284-6.88 6.737-10.254 10.171-1.618 1.646-1.652 3.053-.056 4.689 3.413 3.497 6.829 6.997 10.403 10.326.73.68 2.361 1.107 3.203.755.868-.363 1.601-1.754 1.812-2.811.3-1.513.075-3.132.075-5.015z"
          />
        </svg>
      </router-link>
      <div>
        <div
          v-if="!isModalOpen"
          class="container bg-white rounded-lg mt-3 box-shadow flex-col"
        >
          <p class="w-full text-center text-2xl mb-2">Coberturas</p>
          <p class="w-full text-center text-xs text-gray-600">
            Datos de usuario y coberturas contratadas actualmente:
          </p>
          <p class="bold text-red-600" v-if="modulesAvailableTitular <= 0">
            Titular alcanzó el máximo de coberturas contratadas.
          </p>
          <h3 class="text-left text-lg">
            Socio: {{ coberturasByRFC.names }}
            {{ coberturasByRFC.paternal_name }}
            {{ coberturasByRFC.maternal_name }}
          </h3>
          <h2></h2>
          <div v-if="modulesAvailableTitular === maximunCoveragesTitular">
            Sin coberturas
          </div>
          <div v-else>
            <div class="flex justify-around text-base mb-1 flex-wrap">
              totalModulesDependent
              <div class="seccion font-bold">
                {{ coberturasByRFC.section_name }}
              </div>
              <div class="modulo">
                Modulos Contratados Titular:
                <span class="font-bold">{{ hiresModulesTitular }}</span>
              </div>
              <div class="modulos_disponibles">
                Modulos Disponibles Titular:
                <span class="font-bold">{{ modulesAvailableTitular }}</span>
              </div>
            </div>
            <div class="card">
              <table v-if="showCoberturas" class="table-auto">
                <thead>
                  <tr>
                    <th class="col pt-2">
                      <h3 class="text-left text-sm">Coberturas Contratadas</h3>
                    </th>
                    <th class="col">
                      <h3 class="text-center text-sm">Módulos</h3>
                    </th>
                    <th class="col">
                      <h3 class="text-sm">Suma Asegurada Actual</h3>
                    </th>

                    <th class="col">
                      <h3 class="text-sm">Pago Quincenal</h3>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="coverage in coberturasByRFC.accident_and_illnesess
                      .titular.coverages"
                    :key="coverage.id"
                  >
                    <td class="col">
                      <p class="text-left m-0 text-xs">
                        {{ coverage.type }}
                      </p>
                    </td>
                    <td class="col">
                      <p class="text-center m-0 text-xs">
                        {{ coverage.total_modules }}
                      </p>
                    </td>
                    <td class="col">
                      <p class="text-center m-0 text-xs">
                        {{ $filters.toCurrency(coverage.sum_assured) }}
                      </p>
                    </td>
                    <td class="col">
                      <p class="text-center m-0 text-xs">
                        {{ $filters.toCurrency(coverage.amount) }}
                      </p>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th style="padding-top: 60px;"></th>
                    <th></th>
                    <th></th>
                    <th>
                      <h3 class="text-sm m-0 text-black">
                        <span
                          class="w-2 text-xl border-t-2 text-green-500 pl-6 pr-6 pt-2 border-grey-600"
                          >{{
                            $filters.toCurrency(totalQuincenalTitular)
                          }}</span
                        >
                      </h3>
                    </th>
                  </tr>
                </tfoot>
              </table>

              <div class="w-full flex items-center justify-end sticky mt-3">
                <!-- <h3 class="text-sm m-0 text-left w-1/2 text-black">Módulos Contratados <span class="w-2  text-green-500 ml-2 pl-6 pr-6 pt-2 border-grey-600">{{totalAmountModules}}</span> </h3> -->
                <!-- <div @click="hideCoverage" class="square border-2 border-orange-400 cursor-pointer">

                  <mdicon v-if="showCoberturas" class="text-orange-400" name="chevron-up"/>
                  <mdicon v-else class="text-orange-400" name="chevron-down"/>
                </div> -->
              </div>
            </div>
          </div>
        </div>

        <!-- Carrousel -->
        <div
          v-if="!isModalOpen"
          id="carouselExampleCaptions"
          class="card p-2 mt-3 carousel slide relative"
          data-bs-ride="carousel"
        >
          <div v-if="totalModulesDependent === 0">
            Sin dependientes
          </div>
          <div v-else>
            <h3 class="text-left text-lg">
              Dependientes adicionales
              <!-- <span class="font-bold">{{totalModulesDependent}}</span> -->
            </h3>

            <div class="carousel-inner relative w-full overflow-hidden">
              <button
                class="carousel-control-prev absolute top-0 bottom-0 flex items-center justify-start p-0 text-center border-0 hover:outline-none hover:no-underline focus:outline-none focus:no-underline left-0"
                type="button"
                data-bs-target="#carouselExampleCaptions"
                data-bs-slide="prev"
              >
                <span
                  class="text-black inline-block bg-no-repeat p-2 rounded-full bg-stone-900"
                  aria-hidden="true"
                >
                  <mdicon name="chevron-left" />
                </span>
                <span class="visually-hidden">Previous</span>
              </button>
              <button
                class="carousel-control-next absolute top-0 bottom-0 flex items-center justify-end p-0 text-center border-0 hover:outline-none hover:no-underline focus:outline-none focus:no-underline right-0"
                type="button"
                data-bs-target="#carouselExampleCaptions"
                data-bs-slide="next"
              >
                <span
                  class="text-black inline-block bg-no-repeat p-2 rounded-full bg-stone-900"
                  aria-hidden="true"
                >
                  <mdicon name="chevron-right" />
                </span>
                <span class="visually-hidden">Next</span>
              </button>
              <div
                class="carousel-item relative float-left w-full"
                v-for="(dependentCoverages, index) in coberturasByRFC
                  .accident_and_illnesess.dependents"
                :key="dependentCoverages.id"
                :class="{ active: index == 0 }"
              >
                <div class="flex justify-center">
                  <div class="card w-full flex-row flex-wrap">
                    <div class="w-full">
                      <h5 class="text-left text-lg">
                        Asegurado Adicional: {{ dependentCoverages.names }}
                        {{ dependentCoverages.paternal_name }}
                        {{ dependentCoverages.maternal_name }}
                      </h5>
                    </div>
                    <table class="table-auto w-full">
                      <thead>
                        <tr>
                          <th class="pt-2">
                            <h3 class="text-left text-sm">
                              Coberturas Contratadas
                            </h3>
                          </th>

                          <th class="col">
                            <h3 class="text-center text-sm">Módulos</h3>
                          </th>
                          <th>
                            <h3 class="text-sm">Suma Asegurada Actual</h3>
                          </th>
                          <th>
                            <h3 class="text-sm">Pago Quincenal</h3>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="coverages in dependentCoverages.coverages"
                          :key="coverages.id"
                        >
                          <td class="col">
                            <p class="text-left m-0 text-xs">
                              {{ coverages.type }}
                            </p>
                          </td>
                          <td class="col">
                            <p class=" text-center m-0 text-xs">
                              {{ coverages.total_modules }}
                            </p>
                          </td>
                          <td class="col">
                            <p class="text-center m-0 text-xs">
                              {{ $filters.toCurrency(coverages.sum_assured) }}
                            </p>
                          </td>
                          <td class="col">
                            <p class="text-center m-0 text-xs">
                              {{ $filters.toCurrency(coverages.amount) }}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <th style="padding-top: 60px;"></th>
                          <th></th>
                          <th></th>
                          <th>
                            <h3 class="text-sm m-0 text-black">
                              <span
                                class="text-xl w-2 border-t-2 text-green-500 pl-6 pr-6 pt-2 border-grey-600"
                                >{{
                                  $filters.toCurrency(
                                    getTotalAmountDependent(
                                      dependentCoverages.coverages
                                    )
                                  )
                                }}</span
                              >
                            </h3>
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- Controls -->
            <div
              class="carousel-indicators controls static mx-auto w-full flex justify-center"
            >
              <button
                v-for="(dependentCoverages, index) in coberturasByRFC
                  .accident_and_illnesess.dependents"
                :key="dependentCoverages.id"
                :class="{ active: index == 0 }"
                data-bs-target="#carouselExampleCaptions"
                :data-bs-slide-to="index"
                class="border-0 ball h-5 w-5 active:bg-blue-dark bg-orange-500 rounded-full m-2 "
                aria-current="true"
              ></button>
            </div>
            <div class="w-full">
              <div class="table px-4">
                <div class="flex flex-column items-center md:table-row">
                  <div class="table-cell">
                    <h3 class="text-lg text-left border-none">
                      Total Coberturas
                    </h3>
                  </div>
                  <div class="table-cell"></div>
                  <div class="table-cell after:border-white">
                    <div class="border-none">
                      <h4 class="text-sm text-black">
                        Total de Módulos Adicionales
                      </h4>
                      <span class="w-2 text-green-500 text-lg">{{
                        totalModulesDependent
                      }}</span>
                    </div>
                  </div>
                  <div class="table-cell">
                    <div class="border-none">
                      <h4 class="text-sm text-black">Pago Quincenal</h4>
                      <span class="w-2 text-green-500 text-lg ">{{
                        $filters.toCurrency(totalQuincenalDependent)
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Carrousel -->
      </div>
      <div v-if="showCoveragesDependent != 0" class="container bg-white mt-5  rounded-lg box-shadow  flex-col">
        <div class="bg-white">
          <div v-if="canContractAP" >
            <div
              v-if="!showAP"
              class="w-full  bg-white shadow-xs inline-flex items-center"
            >
              <svg
                @click="hideAP"
                class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 125.445 595.28 590"
              >
                <defs />
                <path
                  d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"
                />
                <path
                  d="M379.492 352.412c10.959-8.219 26.506-5.998 34.725 4.961 6.614 8.819 6.614 20.945 0 29.764l-99.213 99.213c-9.645 9.454-25.08 9.454-34.725 0l-99.213-99.213c-8.219-10.959-5.998-26.506 4.961-34.725 8.819-6.614 20.945-6.614 29.764 0l81.851 81.603 81.851-81.851-.001.248z"
                />
              </svg>
              <span
                @click="hideAP"
                class="cursor-pointer text-sm md:text-xl lg:text-2xl xl:text-2xl font-medium pl-2"
                >Accidentes Personales</span
              >
            </div>
          </div>
          <div v-if="showAP" class="bg-white rounded-lg mt-5 p-3 shadow-lg mb-5">
            <svg
              @click="hideAP"
              class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 125.445 595.28 590"
            >
              <defs />
              <path
                d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"
              />
              <path
                d="M215.788 488.478c-10.959 8.219-26.506 5.998-34.725-4.961-6.614-8.819-6.614-20.945 0-29.764l99.213-99.213c9.645-9.454 25.08-9.454 34.725 0l99.213 99.213c8.219 10.959 5.998 26.506-4.961 34.725-8.819 6.614-20.945 6.614-29.764 0l-81.851-81.603-81.851 81.851.001-.248z"
              />
            </svg>
            <p class="text-gray-700 text-center text-2xl lg:text-4xl mb-2">
              Accidentes personales
            </p>
            <p class="text-gray-600 text-center text-lg lg:text-xl">
              Selecciona la cantidad que deseas recibir de beneficio
            </p>

            <div class="w-full p-2 text-center mt-2 mb-2">
              <v-select
                :searchable="false"
                name="AP"
                ref="selectAP"
                v-model="selectedAPCoverage"
                class="w-full shadow appearance-none border rounded text-grey-darker"
                :options="selectAPOptions"
                :placeholder="'Seleccione la suma asegurada'"
              >
                <template v-slot:no-options>
                  <template> No hay resultados. </template>
                </template>
              </v-select>
            </div>

            <div v-if="selectedAPCoverage != null">
              <table
                v-if="selectedAPCoverage.value != null"
                class="mt-5 mb-5 text-left"
                style="width: 100%"
              >
                <tr
                  v-for="benefit in benefitsAP.result[selectedAPCoverage.value]
                    .benefits"
                  :key="benefit.id"
                >
                  <td class="text-xs lg:text-base text-gray-800">
                    {{ benefit.name }}
                  </td>
                  <td
                    class="text-xs lg:text-base text-gray-800"
                    style="text-align: left"
                  >
                    {{ $filters.toCurrency(benefit.sum_assured) }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div>
          <div v-if="canContractIC">
            <div
              v-if="!showIC"
              class="w-full bg-white shadow-xs inline-flex items-center"
            >
              <svg
                @click="hideIC"
                class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 125.445 595.28 590"
              >
                <defs />
                <path
                  d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"
                />
                <path
                  d="M379.492 352.412c10.959-8.219 26.506-5.998 34.725 4.961 6.614 8.819 6.614 20.945 0 29.764l-99.213 99.213c-9.645 9.454-25.08 9.454-34.725 0l-99.213-99.213c-8.219-10.959-5.998-26.506 4.961-34.725 8.819-6.614 20.945-6.614 29.764 0l81.851 81.603 81.851-81.851-.001.248z"
                />
              </svg>
              <span
                @click="hideIC"
                class="cursor-pointer text-sm md:text-xl lg:text-2xl xl:text-2xl font-medium pl-2"
                >Indemnización por Cáncer</span
              >
            </div>
          </div>

          <div v-if="showIC" class="bg-white rounded-lg mt-5 p-3 shadow-lg mb-5">
            <svg
              @click="hideIC"
              class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 125.445 595.28 590"
            >
              <defs />
              <path
                d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"
              />
              <path
                d="M215.788 488.478c-10.959 8.219-26.506 5.998-34.725-4.961-6.614-8.819-6.614-20.945 0-29.764l99.213-99.213c9.645-9.454 25.08-9.454 34.725 0l99.213 99.213c8.219 10.959 5.998 26.506-4.961 34.725-8.819 6.614-20.945 6.614-29.764 0l-81.851-81.603-81.851 81.851.001-.248z"
              />
            </svg>
            <p class="text-gray-700 text-center text-2xl lg:text-4xl mb-3">
              Indemnización por Cáncer
            </p>
            <p class="text-gray-600 text-center text-lg lg:text-xl">
              Selecciona la cantidad que deseas recibir de beneficio
            </p>

            <div class="w-full p-2 text-center mt-2 mb-2">
              <v-select
                :searchable="false"
                v-model="selectedICCoverage"
                class="w-full shadow appearance-none border rounded text-grey-darker"
                :options="selectICOptions"
                :placeholder="'Seleccione la suma asegurada'"
              >
                <template v-slot:no-options>
                  <template> No hay resultados. </template>
                </template>
              </v-select>
            </div>

            <div v-if="selectedICCoverage != null">
              <table
                v-if="selectedICCoverage.value != null"
                class="mt-5 mb-5 text-left"
                style="width: 100%"
              >
                <tr
                  v-for="benefit in benefitsIC.result[selectedICCoverage.value]
                    .benefits"
                  :key="benefit.id"
                >
                  <td class="text-xs lg:text-base text-gray-800">
                    {{ benefit.name }}
                  </td>
                  <td
                    class="text-xs lg:text-base text-gray-800"
                    style="text-align: left"
                  >
                    {{ $filters.toCurrency(benefit.sum_assured) }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div>
          <div v-if="canContractRH">
            <div
              v-if="!showRH"
              class="w-full bg-white shadow-xs inline-flex items-center"
            >
              <svg
                @click="hideRH"
                class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 125.445 595.28 590"
              >
                <defs />
                <path
                  d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"
                />
                <path
                  d="M379.492 352.412c10.959-8.219 26.506-5.998 34.725 4.961 6.614 8.819 6.614 20.945 0 29.764l-99.213 99.213c-9.645 9.454-25.08 9.454-34.725 0l-99.213-99.213c-8.219-10.959-5.998-26.506 4.961-34.725 8.819-6.614 20.945-6.614 29.764 0l81.851 81.603 81.851-81.851-.001.248z"
                />
              </svg>
              <span
                @click="hideRH"
                class="cursor-pointer text-sm md:text-xl lg:text-2xl xl:text-2xl font-medium pl-2"
                >Respaldo Hospitalario</span
              >
            </div>
          </div>
          <div v-if="showRH" class="bg-white rounded-lg mt-5 p-3 shadow-lg mb-5">
            <svg
              @click="hideRH"
              class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 125.445 595.28 590"
            >
              <defs />
              <path
                d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"
              />
              <path
                d="M215.788 488.478c-10.959 8.219-26.506 5.998-34.725-4.961-6.614-8.819-6.614-20.945 0-29.764l99.213-99.213c9.645-9.454 25.08-9.454 34.725 0l99.213 99.213c8.219 10.959 5.998 26.506-4.961 34.725-8.819 6.614-20.945 6.614-29.764 0l-81.851-81.603-81.851 81.851.001-.248z"
              />
            </svg>
            <p class="text-gray-700 text-center text-2xl lg:text-4xl mb-3">
              Respaldo Hospitalario
            </p>
            <p class="text-gray-600 text-center text-lg lg:text-xl">
              Selecciona la cantidad que deseas recibir de beneficio
            </p>

            <div class="w-full p-2 text-center mt-2 mb-2">
              <v-select
                :searchable="false"
                v-model="selectedRHCoverage"
                class="w-full shadow appearance-none border rounded text-grey-darker"
                :options="selectRHOptions"
                :placeholder="'Seleccione la suma asegurada'"
              >
                <template v-slot:no-options>
                  <template> No hay resultados. </template>
                </template>
              </v-select>
            </div>

            <div v-if="selectedRHCoverage != null">
              <table
                v-if="selectedRHCoverage.value != null"
                class="mt-5 mb-5"
                style="width: 100%"
              >
                <tr
                  v-for="benefit in benefitsRH.result[selectedRHCoverage.value]
                    .benefits"
                  :key="benefit.id"
                >
                  <td class="text-xs lg:text-base text-gray-800">
                    {{ benefit.name }}
                  </td>
                  <td
                    class="text-xs lg:text-base text-gray-800"
                    style="text-align: left"
                  >
                    {{ $filters.toCurrency(benefit.sum_assured) }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div>
          <div v-if="canContractIE">
            <div
              v-if="!showIE"
              class="w-full bg-white shadow-xs inline-flex items-center"
            >
              <svg
                @click="hideIE"
                class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 125.445 595.28 590"
              >
                <defs />
                <path
                  d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"
                />
                <path
                  d="M379.492 352.412c10.959-8.219 26.506-5.998 34.725 4.961 6.614 8.819 6.614 20.945 0 29.764l-99.213 99.213c-9.645 9.454-25.08 9.454-34.725 0l-99.213-99.213c-8.219-10.959-5.998-26.506 4.961-34.725 8.819-6.614 20.945-6.614 29.764 0l81.851 81.603 81.851-81.851-.001.248z"
                />
              </svg>
              <span
                @click="hideIE"
                class="cursor-pointer text-sm md:text-xl lg:text-2xl xl:text-2xl font-medium pl-2"
                >Indemnización por Enfermedades Graves</span
              >
            </div>
          </div>
          <div v-if="showIE" class="bg-white rounded-lg mt-5 p-3 shadow-lg mb-5">
            <svg
              @click="hideIE"
              class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 125.445 595.28 590"
            >
              <defs />
              <path
                d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"
              />
              <path
                d="M215.788 488.478c-10.959 8.219-26.506 5.998-34.725-4.961-6.614-8.819-6.614-20.945 0-29.764l99.213-99.213c9.645-9.454 25.08-9.454 34.725 0l99.213 99.213c8.219 10.959 5.998 26.506-4.961 34.725-8.819 6.614-20.945 6.614-29.764 0l-81.851-81.603-81.851 81.851.001-.248z"
              />
            </svg>
            <p class="text-gray-700 text-center text-2xl lg:text-4xl mb-3">
              Indemnización por Enfermedades Graves
            </p>
            <p class="text-gray-600 text-center text-lg lg:text-xl">
              Selecciona la cantidad que deseas recibir de beneficio
            </p>

            <div class="w-full p-2 text-center mt-2 mb-2">
              <v-select
                :searchable="false"
                v-model="selectedIECoverage"
                class="w-full shadow appearance-none border rounded text-grey-darker"
                :options="selectIEOptions"
                :placeholder="'Seleccione la suma asegurada'"
              >
                <template v-slot:no-options>
                  <template> No hay resultados. </template>
                </template>
              </v-select>
            </div>

            <div v-if="selectedIECoverage != null">
              <table
                v-if="selectedIECoverage.value != null"
                class="mt-5 mb-5 text-left"
                style="width: 100%"
              >
                <tr
                  v-for="benefit in benefitsIE.result[selectedIECoverage.value]
                    .benefits"
                  :key="benefit.id"
                >
                  <td class="text-xs lg:text-base text-gray-800">
                    {{ benefit.name }}
                  </td>
                  <td
                    class="text-xs lg:text-base text-gray-800"
                    style="text-align: left"
                  >
                    {{ $filters.toCurrency(benefit.sum_assured) }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>

        <div>
          <div v-if="canContractPI">
            <div
              v-if="!showPI"
              class="w-full bg-white shadow-xs inline-flex items-center"
            >
              <svg
                @click="hidePI"
                class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 125.445 595.28 590"
              >
                <defs />
                <path
                  d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"
                />
                <path
                  d="M379.492 352.412c10.959-8.219 26.506-5.998 34.725 4.961 6.614 8.819 6.614 20.945 0 29.764l-99.213 99.213c-9.645 9.454-25.08 9.454-34.725 0l-99.213-99.213c-8.219-10.959-5.998-26.506 4.961-34.725 8.819-6.614 20.945-6.614 29.764 0l81.851 81.603 81.851-81.851-.001.248z"
                />
              </svg>
              <span
                @click="hidePI"
                class="cursor-pointer text-sm md:text-xl lg:text-2xl xl:text-2xl font-medium pl-2"
                >Pérdida de Ingresos</span
              >
            </div>
          </div>
          <div v-if="showPI" class="bg-white rounded-lg mt-5 p-3 shadow-lg mb-5">
            <svg
              @click="hidePI"
              class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 125.445 595.28 590"
            >
              <defs />
              <path
                d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"
              />
              <path
                d="M215.788 488.478c-10.959 8.219-26.506 5.998-34.725-4.961-6.614-8.819-6.614-20.945 0-29.764l99.213-99.213c9.645-9.454 25.08-9.454 34.725 0l99.213 99.213c8.219 10.959 5.998 26.506-4.961 34.725-8.819 6.614-20.945 6.614-29.764 0l-81.851-81.603-81.851 81.851.001-.248z"
              />
            </svg>
            <p class="text-gray-700 text-center text-2xl lg:text-4xl mb-3">
              Pérdida de Ingresos
            </p>
            <p class="text-gray-600 text-center text-lg lg:text-xl">
              Selecciona la cantidad que deseas recibir de beneficio
            </p>

            <div class="w-full p-2 text-center mt-2 mb-2">
              <v-select
                :searchable="false"
                v-model="selectedPICoverage"
                class="w-full shadow appearance-none border rounded text-grey-darker"
                :options="selectPIOptions"
                :placeholder="'Seleccione la suma asegurada'"
              >
                <template v-slot:no-options>
                  <template> No hay resultados. </template>
                </template>
              </v-select>
            </div>

            <div v-if="selectedPICoverage != null">
              <table
                v-if="selectedPICoverage.value != null"
                class="mt-5 mb-5 text-left"
                style="width: 100%"
              >
                <tr
                  v-for="benefit in benefitsPI?.result[selectedPICoverage.value]
                    .benefits"
                  :key="benefit.id"
                >
                  <td class="text-xs lg:text-base text-gray-800">
                    {{ benefit.name }}
                  </td>
                  <td
                    class="text-xs lg:text-base text-gray-800"
                    style="text-align: left"
                  >
                    {{ $filters.toCurrency(benefit.sum_assured) }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="container flex-col bg-white rounded-lg mt-5 box-shadow">
        <div class="flex flex justify-around">
          <div>
            <div class="text-2xl m-0 text-center text-gray-800">
              Suma asegurada actual:
              <p class="text-4xl text-center text-green-500 italic font-black">
                {{ $filters.toCurrency(totalSumAssured) }}
              </p>
            </div>
            <div class="text-xl m-0 text-center text-gray-800">
              Prima quincenal actual:
              <p class="text-2xl text-center text-green-500 italic">
                {{ $filters.toCurrency(totalPrimaQuincenal) }}
              </p>
            </div>
          </div>
          <div>
            <div class="text-2xl m-0 text-center text-gray-800">
              Suma asegurada contratada:
              <p class="text-4xl text-center text-green-500 italic font-black">
                {{ $filters.toCurrency(sumAssuredTotal) }}
              </p>
            </div>
            <div class="text-xl m-0 text-center text-gray-800">
              Prima quincenal contratada:
              <p class="text-2xl text-center text-green-500 italic">
                {{ $filters.toCurrency(primaQuincenalHired) }}
              </p>
            </div>
          </div>
        </div>
        <div class="w-full">
          <div class="text-xl m-0 text-center text-gray-800">
            Prima quincenal total:
            <p class="text-4xl text-center text-green-500 italic font-black">
              {{
                $filters.toCurrency(primaQuincenalHired + totalPrimaQuincenal)
              }}
            </p>
          </div>
        </div>
        <div class="w-full text-center">
          <button
            id="button_contract"
            @click="registerNewQuote"
            class="w-full flex items-center justify-center mx-auto  md:w-2/5 lg:w-2/5 xl:w-2/5 bg-orange-600 hover:bg-orange-700 text-2xl text-white font-bold py-2 px-6 rounded"
          >
            Contratar <mdicon name="chevron-right" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import emptyPolicy from "../assets/EmptyPolicy.json";
import Loading from "vue-loading-overlay";
//import resumeCoberturas from '@/assets/dev_resumen_socios_coberturas_contratadas.json';

export default {
  name: "BenefitByRFC",
  components: { Loading },
  data() {
    return {
      moduleSelected: "",
      isModalOpen: true,
      hiresModulesTitular: 0,
      totalQuincenalTitular: 0,
      totalQuincenalDependent: 0,
      totalModulesDependent: 0,
      totalSumAssured: 0,
      totalPrimaQuincenal: 0,
      totalModulesAP: 0,
      totalModulesIC: 0,
      totalModulesRH: 0,
      totalModulesIE: 0,
      totalModulesPI: 0,
      coberturasByRFC: null,
      maximunCoveragesTitular: 15,
      maximunCoveragesDependent: 9,
      showCoverage: true,
      isLoading: false,
      policy: null,
      age: null,
      ccAPI: process.env.VUE_APP_CCAPI,
      reference: null,
      section: null,
      showCoberturas: true,
      showAP: false,
      showIC: false,
      showRH: false,
      showIE: false,
      showPI: false,
      canContractAP: false,
      canContractIC: false,
      canContractRH: false,
      canContractIE: false,
      canContractPI: false,
      selectedAPCoverage: [],
      selectedICCoverage: [],
      selectedRHCoverage: [],
      selectedIECoverage: [],
      selectedPICoverage: [],
      benefitsAP: [],
      benefitsIC: [],
      benefitsRH: [],
      benefitsIE: [],
      benefitsPI: [],
      contractAP: false,
      listaBeneficios: null,
      jsonLength: null,
      finalJSON: [],
      formula: null,
      protated_cost_plan_a_AP: 0,
      protated_cost_plan_b_AP: 0,
      plan_a_number_AP: 0,
      plan_b_number_AP: 0,
      admin_cost_plan_a_AP: 0,
      admin_cost_plan_b_AP: 0,
      protated_cost_plan_a_IC: 0,
      protated_cost_plan_b_IC: 0,
      plan_a_number_IC: 0,
      plan_b_number_IC: 0,
      admin_cost_plan_a_IC: 0,
      admin_cost_plan_b_IC: 0,
      protated_cost_plan_a_RH: 0,
      protated_cost_plan_b_RH: 0,
      plan_a_number_RH: 0,
      plan_b_number_RH: 0,
      admin_cost_plan_a_RH: 0,
      admin_cost_plan_b_RH: 0,
      protated_cost_plan_a_IE: 0,
      protated_cost_plan_b_IE: 0,
      plan_a_number_IE: 0,
      plan_b_number_IE: 0,
      admin_cost_plan_a_IE: 0,
      admin_cost_plan_b_IE: 0,
      protated_cost_plan_a_PI: 0,
      protated_cost_plan_b_PI: 0,
      plan_a_number_PI: 0,
      plan_b_number_PI: 0,
      admin_cost_plan_a_PI: 0,
      admin_cost_plan_b_PI: 0,
      valueAP: 0,
      valueIC: 0,
      valueRH: 0,
      valueIE: 0,
      valuePI: 0,
      api_lineamagisterialproducts:
        process.env.VUE_APP_APILINEAMAGISTERIALPRODUCTS,
      api_CABSACORE: process.env.VUE_APP_APICABSACORE,
      token_auth: "",
      client_id: 1
    };
  },
  async created() {
    Swal.fire({
      title: '<h4 class="mt-4">¿Ya tienes coberturas contratadas?</h4>',
      html: `
        <div class="text-sm w-full sm:w-3/5 flex flex-column mx-auto">
          <div class="group flex justify-between">
            <button id='button_yes' class="bg-gray-300 rounded border-2 py-2 px-12">Si</button>
            <button id="close-swal" class="rounded border-2 py-2 px-12">No</button>
          </div>
          <input onkeyup="this.value = this.value.toUpperCase()" id="swal-input1" placeholder="Ingresa tu R.F.C" class="swal2-input">
        <div>
        `,
      focusConfirm: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText:
        "<div class='flex' id='button_see_coverage'>Ver coberturas <svg fill='currentColor' width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><!----><path d='M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z'></path></svg><div>",
      confirmButtonColor: "#dd6b20",

      preConfirm: async () => {
        const rfc = document.getElementById("swal-input1");
        if (rfc.value.trim() === "") {
          return Swal.showValidationMessage(`Debe de ingresar un RFC`);
        }
        this.setRFCStorage(rfc)
        return await axios
          .get(
            `${this.ccAPI}lm/accidents_and_illnesses/get_summary_contracted_coverage_by_rfc/`,
            { params: { rfc: rfc.value } }
          )
          .then((data) => {
            console.log("rfc Benefit: ", rfc.value)
            this.getDateByRFC(rfc.value)
            this.coberturasByRFC = data.data.response;
            this.coberturasByRFC = data.data.response;
            this.getTotalAmountTitular();
            this.getTotalModuleDependent();
            this.getTotalAmountModulesByCoverage();
            this.setClientDataToStorage(data.data.response);
            this.searchClient(rfc.value)
            this.isModalOpen = false;
          })
          .catch((error) => {
            Swal.showValidationMessage(`Error: ${error.response.data.errors}`);
          })
          .finally(() => {
            rfc.value = "";
          });
      },
    });

    await this.getTokenAuth();
    this.getDataFromLocalStore();
    this.getCanContract();
    this.getCantContract();
    this.getListOfBenefitsAP();
    this.getListOfBenefitsIC();
    this.getListOfBenefitsRH();
    this.getListOfBenefitsIE();
    this.getListOfBenefitsPI();
    this.getFormulaforCalculteAdminCost();
  },
  mounted() {


    this.verifyExistsItemStorage();

    document.getElementById("close-swal")?.addEventListener("click", () => {
      Swal.close();
      this.isModalOpen = true;
    });
  },
  unmounted() {
    Swal.close();
  },
  watch: {
    selectedAPCoverage(value) {
      if (this.selectedAPCoverage?.label) {
        this.setItem("ap_label", this.selectedAPCoverage.label);
        this.setItem("ap_value", this.selectedAPCoverage.value);
      }
      if (value === null) {
        this.removeItem("ap_label", "ap_value");
        return;
      }
      this.moduleSelected = "AP";
    },
    selectedICCoverage(value) {
      if (this.selectedICCoverage?.label) {
        this.setItem("ic_label", this.selectedICCoverage.label);
        this.setItem("ic_value", this.selectedICCoverage.value);
      }

      if (value === null) {
        this.removeItem("ic_label", "ic_value");
        return;
      }
      this.moduleSelected = "IC";
    },
    selectedRHCoverage(value) {
      if (this.selectedRHCoverage?.label) {
        this.setItem("rh_label", this.selectedRHCoverage.label);
        this.setItem("rh_value", this.selectedRHCoverage.value);
      }

      if (value === null) {
        this.removeItem("rh_label", "rh_value");
        return;
      }
      this.moduleSelected = "RH";
    },
    selectedIECoverage(value) {
      if (this.selectedIECoverage?.label) {
        this.setItem("ie_label", this.selectedIECoverage.label);
        this.setItem("ie_value", this.selectedIECoverage.value);
      }

      if (value === null) {
        this.removeItem("ie_label", "ie_value");
        return;
      }
      this.moduleSelected = "IE";
    },
    selectedPICoverage(value) {
      if (this.selectedPICoverage?.label) {
        this.setItem("pi_label", this.selectedPICoverage.label);
        this.setItem("pi_value", this.selectedPICoverage.value);
      }

      if (value === null) {
        this.removeItem("pi_label", "pi_value");
        return;
      }
      this.moduleSelected = "PI";
    },
  },
  methods: {
    async searchClient(rfc){
      await axios.get(
        `${this.ccAPI}cabsaaye/client/get_by_rfc/`,
        { params: { rfc: rfc } }
      )
      .then((data) => {
        this.client_id = data.data.response.data.id
      })
    },
    validateAgeWithRFC(age){
      const ageStorage = Number(localStorage.getItem("age") || '{}');
      const kinship = localStorage.getItem("kinship") || '{}';
      if(kinship === "Titular"){
        if(isNaN(ageStorage)){
          return;
        }
        if(ageStorage !== age){
          Swal.fire({
            icon: 'warning',
            text: 'RFC no coincide con edad ingresada en cotización',
            buttonConfirmText: 'ok'
          }).then(() => {
            console.log("Se quita modal");
            this.$router.push({ name: "quotation" });
          })
          //this.rfc = '';
        }
      }

    },
    async getDateByRFC(rfc) {
      //await this.login();
      axios
        .get(this.ccAPI + "get_date_by_rfc", {
          params: {
            rfc,
            token_auth: this.token_auth,
          },
        })
        .then((response) => {
          moment.locale("es");
          let currentDate = moment();
          const age = moment(response.data.response.date, 'YYYY-MM-DD').diff(currentDate, 'years') * -1;
          this.validateAgeWithRFC(age);
        })
        .catch((error) => {
          console.log("Error al validar la fecha de nacimiento: ", error);
        });
    },
    setClientDataToStorage(dataClient){
      const objDataClient = { 
        maternal_name: dataClient.maternal_name,
        paternal_name: dataClient.paternal_name,
        names: dataClient.names,
        rfc: dataClient.rfc}
      localStorage.setItem("data_client", JSON.stringify(objDataClient));
    },
    setRFCStorage(rfc){
      localStorage.setItem("rfc_client", rfc.value)
    },
    async getTokenAuth(){
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      let data = {
        user: {
          email: "aplm@gcabsa.com.mx",
          password: "cabsa2022",
        },
      };

      await axios.post(this.ccAPI + "/fas/login", data, config).then((dataa) => {
        this.token_auth = dataa.data.token_auth;
      });
    },
    getFormulaforCalculteAdminCost() {
      axios
        .get(this.ccAPI+"/get_formula_cost_administrative", {
          params: {
            token_auth: this.token_auth,
            name_section: this.sectionDescription,
            type_policy: "seguro",
            type_payment: this.payment_type.replaceAll("Ó","O").replaceAll("%",""),
            config: "calcular",
          },
        })
        .then((response) => {
          this.formula = response.data.formula;
        })
        .catch((error) => {
          console.log("Se presento un error: ", error);
        });
    },
    verifyExistsItemStorage() {
      if (localStorage.getItem("ap_label")) {
        this.showAP = true;
        this.canContractAP = true;
      }
      if (localStorage.getItem("ic_label")) {
        this.showIC = true;
        this.canContractIC = true;
      }
      if (localStorage.getItem("rh_label")) {
        this.showRH = true;
        this.canContractRH = true;
      }
      if (localStorage.getItem("ie_label")) {
        this.showIE = true;
        this.canContractIE = true;
      }
      if (localStorage.getItem("pi_label")) {
        this.showPI = true;
        this.canContractPI = true;
      }
    },
    //methods for local storage
    removeItem(label_a, label_b) {
      localStorage.removeItem(label_a);
      localStorage.removeItem(label_b);
    },
    setItem(name, value) {
      localStorage.setItem(name, value);
    },
    getItem(value) {
      if (!localStorage.getItem(value)) {
        return null;
      }
      return localStorage.getItem(value);
    },
    addSelectedStorage(label, value) {
      if (this.getItem(label) && this.getItem(value)) {
        const obj = {
          label: this.getItem(label),
          value: Number(this.getItem(value)),
        };
        return obj;
      }
    },
    getSelectedAPStorage() {
      this.selectedAPCoverage = this.addSelectedStorage("ap_label", "ap_value");
      this.showAP = true;
      this.canContractIC = true;
    },
    getSelectedICStorage() {
      this.selectedICCoverage = this.addSelectedStorage("ic_label", "ic_value");
      this.showIC = true;
      this.canContractIC = true;
    },
    getSelectedRHStorage() {
      this.selectedRHCoverage = this.addSelectedStorage("rh_label", "rh_value");
      this.showRH = true;
      this.canContractRH = true;
    },
    getSelectedIEStorage() {
      this.selectedIECoverage = this.addSelectedStorage("ie_label", "ie_value");
      this.showIE = true;
      this.canContractIE = true;
    },
    getSelectedPIStorage() {
      this.selectedPICoverage = this.addSelectedStorage("pi_label", "pi_value");
      this.showPI = true;
      this.canContractPI = true;
    },
    getTotalModulesByCoverage(moduleSelected) {
      switch (moduleSelected) {
        case "AP":
          if (
            !this.calculateAvailableModulesSelected(
              this.getTotalSumAP,
              this.totalModulesAP
            )
          ) {
            return false;
          }
          break;
        case "IC":
          if (
            !this.calculateAvailableModulesSelected(
              this.getTotalSumIC,
              this.totalModulesIC
            )
          ) {
            return false;
          }
          break;
        case "RH":
          if (
            !this.calculateAvailableModulesSelected(
              this.getTotalSumRH,
              this.totalModulesRH
            )
          ) {
            return false;
          }
          break;
        case "IE":
          if (
            !this.calculateAvailableModulesSelected(
              this.getTotalSumIE,
              this.totalModulesIE
            )
          ) {
            return false;
          }
          break;
        case "PI":
          if (
            !this.calculateAvailableModulesSelected(
              this.getTotalSumPI,
              this.totalModulesPI
            )
          ) {
            return false;
          }
          break;
      }
      return true;
    },

    setSelectedValueToNull() {
      switch (this.moduleSelected) {
        case "AP":
          this.selectedAPCoverage = null;
          break;
        case "IC":
          this.selectedICCoverage = null;
          break;
        case "RH":
          this.selectedRHCoverage = null;
          break;
        case "IE":
          this.selectedIECoverage = null;
          break;
        case "PI":
          this.selectedPICoverage = null;
          break;
      }
    },
    getCoverageNameByNomenclature(nomenclature) {
      switch (nomenclature) {
        case "AP":
          return "Accidentes Personales";
        case "IC":
          return "Idemnización por Cáncer";
        case "RH":
          return "Respaldo Hospitalario";
        case "IE":
          return "Indemnización por Enfermedades Graves";
        case "PI":
          return "Pérdida de Ingresos";
      }
    },
    getTotalModulesSelected() {
      let total =
        this.getTotalSumAP +
        this.getTotalSumIC +
        this.getTotalSumRH +
        this.getTotalSumIE +
        this.getTotalSumPI;
      return total;
    },
    showAlertMaximunModulesReached() {
      Swal.fire({
        title: "Aviso!",
        text: "Cobertura seleccionada sobrepasa los modulos disponibles",
        icon: "warning",
        confirmButtonText: "Aceptar",
      });
    },
    showAlertMaximunCoverageReached(coverageType) {
      const text = this.validateLimitModulesByCoverage(coverageType);

      Swal.fire({
        title: "Aviso!",
        text: text,
        icon: "warning",
        confirmButtonText: "Aceptar",
      });
    },
    validateLimitModulesByCoverage(coverageType) {
      let text1 =
        "Usted ya cuenta con el máximo número de módulos para la cobertura " +
        coverageType;
      let text2 =
        "Módulo Seleccionado supera el máximo de módulos para la cobertura " +
        coverageType;
      switch (this.moduleSelected) {
        case "AP":
          return this.totalModulesPI < 3 ? text2 : text1;
        case "IC":
          return this.totalModulesIC < 3 ? text2 : text1;
        case "RH":
          return this.totalModulesRH < 3 ? text2 : text1;
        case "IE":
          return this.totalModulesIE < 3 ? text2 : text1;
        case "PI":
          return this.totalModulesPI < 3 ? text2 : text1;
      }
    },
    /* Aqui me quedé */
    calculateAvailableModulesSelected(selectedModules, actualModules) {
      if (this.isCoverageByTitular()) {
        let result = selectedModules + actualModules;
        if (result > 3) {
          return false;
        }
      }
      return true;
    },
    calculateAvailableModules() {
      let result =
        this.modulesAvailableTitular - this.getTotalModulesSelected();
      if (result < 0) {
        return false;
      }
      return true;
    },
    calculateAvailableModulesDependent() {
      let result = this.totalModulesDependent - this.getTotalModulesSelected();
      if (result < 0) {
        return false;
      }
      return true;
    },
    getTotalAmountModulesByCoverage() {
      if (this.isCoverageByTitular()) {
        this.coberturasByRFC.accident_and_illnesess.titular.coverages.map(
          (coverage) => {
            if (coverage.type == "Accidentes Personales") {
              this.totalModulesAP += coverage.total_modules;
            }
            if (coverage.type == "Respaldo Hospitalario") {
              this.totalModulesRH += coverage.total_modules;
            }
            if (coverage.type == "Indemnización por Cáncer") {
              this.totalModulesIC += coverage.total_modules;
            }
            if (coverage.type == "Indemnización por Enf Graves") {
              this.totalModulesIE += coverage.total_modules;
            }
            if (coverage.type == "Pérdida de Ingresos") {
              this.totalModulesPI += coverage.total_modules;
            }
          }
        );
      } else {
        this.coberturasByRFC.accident_and_illnesess.dependents.map(
          (dependents) => {
            dependents.coverages.map((coverage) => {
              console.log("getTotalAmountModulesByCoverage: ", coverage);
              if (coverage.type == "Accidentes Personales") {
                //this.totalModulesAP += coverage.total_modules;
                this.totalModulesAP += 0;
              }
              if (coverage.type == "Respaldo Hospitalario") {
                //this.totalModulesRH += coverage.total_modules;
                this.totalModulesRH += 0;
              }
              if (coverage.type == "Indemnización por Cáncer") {
                //this.totalModulesIC += coverage.total_modules;
                this.totalModulesIC += 0;
              }
              if (coverage.type == "Indemnización por Enf Graves") {
                this.totalModulesIE += 0;
              }
              if (coverage.type == "Pérdida de Ingresos") {
                this.totalModulesPI += 0;
              }
            });
          }
        );
      }
    },
    getTotalAmountTitular() {
      this.coberturasByRFC.accident_and_illnesess.titular.coverages.map(
        (coverage) => {
          this.totalPrimaQuincenal += Number(coverage.amount);
          this.totalSumAssured += Number(coverage.sum_assured);
          this.hiresModulesTitular += coverage.total_modules;
          this.totalQuincenalTitular += Number(coverage.amount);
        }
      );
    },

    getTotalAmountDependent(array) {
      let total = 0;
      array.map((value) => (total += Number(value.amount)));
      return total;
    },

    getTotalModuleDependent() {
      this.coberturasByRFC.accident_and_illnesess.dependents.map(
        (dependents) => {
          dependents.coverages.map((coverage) => {
            this.totalPrimaQuincenal += Number(coverage.amount);
            this.totalSumAssured += Number(coverage.sum_assured);
            this.totalModulesDependent += coverage.total_modules;
            this.totalQuincenalDependent += Number(coverage.amount);
          });
        }
      );
    },
    isCoverageByTitular() {
      const kinship = localStorage.getItem("kinship");
      if (kinship !== "Titular") {
        return false;
      }
      return true;
    },
    getDataFromLocalStore() {
      this.age = localStorage.age;
      this.reference = localStorage.reference;
      this.section = localStorage.section;
      this.sectionDescription = localStorage.sectionDescription;
      this.kinship = localStorage.kinship;
      this.maritalStatus = localStorage.maritalStatus;
      this.payment_type = localStorage.payment_type;
    },
    getCantContract() {
      if (
        !this.canContractAP &&
        !this.canContractIC &&
        !this.canContractRH &&
        !this.canContractIE &&
        !this.canContractPI
      ) {
        Swal.fire(
          "Cobertura no disponible",
          "Los datos ingresados no coinciden con las requisitos necesarios.",
          "info"
        );
        /* this.$router.push({ name: "/benefitByReference" }); */
      }
    },
    getCanContract() {
      // La cobertura Accidentes Personales solo se debe mostrar si la edad es menor o igual a 69 años
      //titular
      if (this.kinship == "Titular" && this.age >= 18 && this.age <= 69 ) {
        this.canContractAP = true;
      }
      //dependiente
      //if (this.kinship != "Titular" && this.age > 16 && this.age <= 69){
      //  this.canContractAP = true;
      //}





      // // La cobertura Perdida de ingresos solo se debe mostrar si la edad es mayor a 16 años
      // // La cobertura Perdida de ingresos solo se debe mostrar si la edad es menor o igual a 64 años
      //titular
      if (this.kinship == "Titular" && this.age >= 18 && this.age <= 64 ) {
        this.canContractPI = true;
      }
      //dependiente
      //if (this.kinship != "Titular" && this.age > 16 && this.age <= 64){
      //  this.canContractPI = true;
      //}




      // La cobertura Cáncer
      // La cobertura Cáncer solo se debe mostrar si la edad es menor o igual a 69 años
      //titular
      if (this.kinship == "Titular" && this.age >= 18 && this.age <= 69) {
        this.canContractIC = true;
      }

      //dependiente
      if (this.kinship != "Titular" && this.age <= 69) {
        if (this.kinship == "Padres" && this.maritalStatus == "Soltero(a)") {
          this.canContractIC = true;
        }

        if (this.kinship == "Hijo(a)" && this.age > 0 && this.age <= 25) {
          this.canContractIC = true;
        }

        if ( (this.kinship == "Cónyugue" && this.maritalStatus == "Casado(a)" && this.age > 16) ||
              (this.kinship == "Cónyugue" && this.maritalStatus == "Concubinato" && this.age > 16) ) 
        {
          this.canContractIC = true;
        }
      }



      // La cobertura Respaldo Hospitalario solo se debe mostrar si la edad es menor o igual a 64 años
      //titular
      if (this.kinship == "Titular" && this.age >= 18 && this.age <= 64 ) {
        this.canContractRH = true;
      }
      //dependiente
      if (this.kinship != "Titular" && this.age > 16 && this.age <= 64){
        if (this.kinship == "Padres" && this.maritalStatus == "Soltero(a)") {
          this.canContractRH = true;
        }

        if (this.kinship == "Hijo(a)" && this.age <= 25) {
          this.canContractRH = true;
        }
        if ( (this.kinship == "Cónyugue" && this.maritalStatus == "Casado(a)" && this.age > 16) ||
              (this.kinship == "Cónyugue" && this.maritalStatus == "Concubinato" && this.age > 16) ) 
        {
          this.canContractRH = true;
        }
      }



      // // La cobertura Enfermedades Graves solo se debe mostrar si la edad es menor o igual a 64 años
      //titular
      if (this.kinship == "Titular" && this.age >= 18 && this.age <= 64 ) {
        this.canContractIE = true;
      }
      //dependiente
      if (this.kinship != "Titular" && this.age <= 64){
        if (this.kinship == "Padres" && this.maritalStatus == "Soltero(a)") {
          this.canContractIE = true;
        }

        if (this.kinship == "Hijo(a)" && this.age > 0 && this.age <= 25) {
          this.canContractIE = true;
        }
        if ( (this.kinship == "Cónyugue" && this.maritalStatus == "Casado(a)" && this.age > 16) ||
              (this.kinship == "Cónyugue" && this.maritalStatus == "Concubinato" && this.age > 16) ) 
        {
          this.canContractIE = true;
        }
      }

    },
    getListOfBenefitsAP() {
      if (this.canContractAP == true) {
        axios
          .get(this.api_lineamagisterialproducts + "/quoter/list_of_benefits", {
            params: {
              product_id: 1,
              age: this.age,
            },
          })
          .then((response) => {
            this.benefitsAP = response.data;
            for (let i = 0; i < this.benefitsAP.result.length; i++) {
              this.benefitsAP.result[i].positionArray = i;
            }
            this.selectedAPCoverage = this.addSelectedStorage(
              "ap_label",
              "ap_value"
            );
          })
          .catch((error) => {
            console.log("Se presento un error: ", error);
          });
      }
    },
    getListOfBenefitsIC() {
      if (this.canContractIC == true) {
        axios
          .get(this.api_lineamagisterialproducts + "/quoter/list_of_benefits", {
            params: {
              product_id: 2,
              age: this.age,
            },
          })
          .then((response) => {
            this.benefitsIC = response.data;
            for (let i = 0; i < this.benefitsIC.result.length; i++) {
              this.benefitsIC.result[i].positionArray = i;
            }
            this.selectedICCoverage = this.addSelectedStorage(
              "ic_label",
              "ic_value"
            );
          });
      }
    },
    getListOfBenefitsRH() {
      if (this.canContractRH == true) {
        axios
          .get(this.api_lineamagisterialproducts + "/quoter/list_of_benefits", {
            params: {
              product_id: 3,
              age: this.age,
            },
          })
          .then((response) => {
            this.benefitsRH = response.data;
            for (let i = 0; i < this.benefitsRH.result.length; i++) {
              this.benefitsRH.result[i].positionArray = i;
            }
            this.selectedRHCoverage = this.addSelectedStorage(
              "rh_label",
              "rh_value"
            );
          });
      }
    },
    getListOfBenefitsIE() {
      if (this.canContractIE == true) {
        axios
          .get(this.api_lineamagisterialproducts + "/quoter/list_of_benefits", {
            params: {
              product_id: 4,
              age: this.age,
            },
          })
          .then((response) => {
            this.benefitsIE = response.data;
            console.log("benefitsIE: ", this.benefitsIE);
            for (let i = 0; i < this.benefitsIE.result.length; i++) {
              this.benefitsIE.result[i].positionArray = i;
            }
            this.selectedIECoverage = this.addSelectedStorage(
              "ie_label",
              "ie_value"
            );
          });
      }
    },
    getListOfBenefitsPI() {
      if (this.canContractPI == true) {
        axios
          .get(this.api_lineamagisterialproducts + "/quoter/list_of_benefits", {
            params: {
              product_id: 5,
              age: this.age,
            },
          })
          .then((response) => {
            this.benefitsPI = response.data;
            for (let i = 0; i < this.benefitsPI.result.length; i++) {
              this.benefitsPI.result[i].positionArray = i;
            }
            this.selectedPICoverage = this.addSelectedStorage(
              "pi_label",
              "pi_value"
            );
          })
          .catch((error) => {
            console.log("Se presento un error: ", error);
          });
      }
    },
    hideCoverage() {
      this.showCoberturas = !this.showCoberturas;
    },
    hideAP() {
      this.showAP = !this.showAP;
    },
    hideIC() {
      this.showIC = !this.showIC;
    },
    hideRH() {
      this.showRH = !this.showRH;
    },
    hideIE() {
      this.showIE = !this.showIE;
    },
    hidePI() {
      this.showPI = !this.showPI;
    },
    makeJSON() {
      this.finalJSON = [];
      // AP
      // var valueAP = 0;
      var benefitsAPArray = [];
      var benefitAPText;
      var benefitAPValue;
      var benefitAPPlanA;
      var benefitAPPlanB;
      var benefitAPSumAssuredTotal;
      var benefitAPCost;
      var quoteAP;
      var unitCostPlanA;
      var unitCostPlanB;
      var unitCostRoundedPlanA;
      var unitCostRoundedPlanB;

      if (this.selectedAPCoverage != null) {
        if (this.selectedAPCoverage.value >= 0) {
          /*valueAP = Number(
            this.benefitsAP.result[this.selectedAPCoverage.value].costo_total
          );*/

          for (
            let i = 0;
            i <
            this.benefitsAP.result[this.selectedAPCoverage.value].benefits
              .length;
            i++
          ) {
            benefitAPText = this.benefitsAP.result[
              this.selectedAPCoverage.value
            ].benefits[i].name;
            benefitAPValue = this.benefitsAP.result[
              this.selectedAPCoverage.value
            ].benefits[i].sum_assured;
            benefitAPPlanA = this.benefitsAP.result[
              this.selectedAPCoverage.value
            ].plan_a_number;
            benefitAPPlanB = this.benefitsAP.result[
              this.selectedAPCoverage.value
            ].plan_b_number;
            benefitAPSumAssuredTotal = this.benefitsAP.result[
              this.selectedAPCoverage.value
            ].sum_assured;
            benefitAPCost = this.benefitsAP.result[
              this.selectedAPCoverage.value
            ].costo;
            unitCostPlanA = this.benefitsAP.result[
              this.selectedAPCoverage.value
            ].costo_plan_a;
            unitCostPlanB = this.benefitsAP.result[
              this.selectedAPCoverage.value
            ].costo_plan_b;
            unitCostRoundedPlanA = this.benefitsAP.result[
              this.selectedAPCoverage.value
            ].costo_redondeado_plan_a;
            unitCostRoundedPlanB = this.benefitsAP.result[
              this.selectedAPCoverage.value
            ].costo_redondeado_plan_b;

            benefitsAPArray.push({
              plan_a: benefitAPPlanA,
              plan_b: benefitAPPlanB,
              sum_assured: benefitAPSumAssuredTotal,
              price: benefitAPCost,
              unit_cost_plan_a: Number(unitCostPlanA).toFixed(2),
              unit_cost_plan_b: Number(unitCostPlanB).toFixed(2),
              unit_cost_plan_a_rounded: Number(unitCostRoundedPlanA).toFixed(2),
              unit_cost_plan_b_rounded: Number(unitCostRoundedPlanB).toFixed(2),
              unit_cost_plan_a_prorated: this.protated_cost_plan_a_AP,
              unit_cost_plan_b_prorated: this.protated_cost_plan_b_AP,
              admin_cost_plan_a: this.admin_cost_plan_a_AP,
              admin_cost_plan_b: this.admin_cost_plan_b_AP,
              benefits: { name: benefitAPText, sum_assured: benefitAPValue },
            });
          }
          quoteAP = {
            cost: this.valueAP,
            age: this.age,
            product_name: "Accidentes Personales",
            referenced: this.reference,
            benefits: benefitsAPArray,
            product_id: 1,
            client_id: this.client_id,
            bussines_id: this.section,
          };
          this.finalJSON.push(quoteAP);
          this.contractAP = true;
          localStorage.setItem("contractAP", this.contractAP);
        } else {
          this.contractAP = false;
        }
      }

      // IC
      //var valueIC = 0;
      var benefitsICArray = [];
      var benefitICText;
      var benefitICValue;
      var benefitICPlanA;
      var benefitICPlanB;
      var benefitICSumAssuredTotal;
      var benefitICCost;
      var quoteIC;
      var unitCostICPlanA;
      var unitCostICPlanB;
      var unitCostICRoundedPlanA;
      var unitCostICRoundedPlanB;

      if (this.selectedICCoverage != null) {
        if (this.selectedICCoverage.value >= 0) {
          /*valueIC = Number(
            this.benefitsIC.result[this.selectedICCoverage.value].costo_total
          );*/

          for (
            let i = 0;
            i <
            this.benefitsIC.result[this.selectedICCoverage.value].benefits
              .length;
            i++
          ) {
            benefitICText = this.benefitsIC.result[
              this.selectedICCoverage.value
            ].benefits[i].name;
            benefitICValue = this.benefitsIC.result[
              this.selectedICCoverage.value
            ].benefits[i].sum_assured;
            benefitICPlanA = this.benefitsIC.result[
              this.selectedICCoverage.value
            ].plan_a_number;
            benefitICPlanB = this.benefitsIC.result[
              this.selectedICCoverage.value
            ].plan_b_number;
            benefitICSumAssuredTotal = this.benefitsIC.result[
              this.selectedICCoverage.value
            ].sum_assured;
            benefitICCost = this.benefitsIC.result[
              this.selectedICCoverage.value
            ].costo; //costo_total
            unitCostICPlanA = this.benefitsIC.result[
              this.selectedICCoverage.value
            ].costo_plan_a; //costo_unitario_a
            unitCostICPlanB = this.benefitsIC.result[
              this.selectedICCoverage.value
            ].costo_plan_b; //costo_unitario_b
            unitCostICRoundedPlanA = this.benefitsIC.result[
              this.selectedICCoverage.value
            ].costo_redondeado_plan_a;
            unitCostICRoundedPlanB = this.benefitsIC.result[
              this.selectedICCoverage.value
            ].costo_redondeado_plan_b;

            benefitsICArray.push({
              benefits: { name: benefitICText, sum_assured: benefitICValue },
              plan_a: benefitICPlanA,
              plan_b: benefitICPlanB,
              sum_assured: benefitICSumAssuredTotal,
              cost: benefitICCost,
              unit_cost_plan_a: Number(unitCostICPlanA).toFixed(2),
              unit_cost_plan_b: Number(unitCostICPlanB).toFixed(2),
              unit_cost_plan_a_rounded: Number(unitCostICRoundedPlanA).toFixed(
                2
              ),
              unit_cost_plan_b_rounded: Number(unitCostICRoundedPlanB).toFixed(
                2
              ),
              unit_cost_plan_a_prorated: this.protated_cost_plan_a_IC,
              unit_cost_plan_b_prorated: this.protated_cost_plan_b_IC,
              admin_cost_plan_a: this.admin_cost_plan_a_IC,
              admin_cost_plan_b: this.admin_cost_plan_b_IC,
            });
          }
          quoteIC = {
            cost: this.valueIC,
            age: this.age,
            product_name: "Indemnización por Cáncer",
            referenced: this.reference,
            benefits: benefitsICArray,
            product_id: 2,
            client_id: this.client_id,
            bussines_id: this.section,
          };
          this.finalJSON.push(quoteIC);
        }
      }

      // RH
      //var valueRH = 0;
      var benefitsRHArray = [];
      var benefitRHText;
      var benefitRHValue;
      var benefitRHPlanA;
      var benefitRHPlanB;
      var benefitRHSumAssuredTotal;
      var benefitRHCost;
      var quoteRH;
      var unitCostRHPlanA;
      var unitCostRHPlanB;
      var unitCostRHRoundedPlanA;
      var unitCostRHRoundedPlanB;

      if (this.selectedRHCoverage != null) {
        if (this.selectedRHCoverage.value >= 0) {
          /*valueRH = Number(
            this.benefitsRH.result[this.selectedRHCoverage.value].costo_total
          );*/

          for (
            let i = 0;
            i <
            this.benefitsRH.result[this.selectedRHCoverage.value].benefits
              .length;
            i++
          ) {
            benefitRHText = this.benefitsRH.result[
              this.selectedRHCoverage.value
            ].benefits[i].name;
            benefitRHValue = this.benefitsRH.result[
              this.selectedRHCoverage.value
            ].benefits[i].sum_assured;
            benefitRHPlanA = this.benefitsRH.result[
              this.selectedRHCoverage.value
            ].plan_a_number;
            benefitRHPlanB = this.benefitsRH.result[
              this.selectedRHCoverage.value
            ].plan_b_number;
            benefitRHSumAssuredTotal = this.benefitsRH.result[
              this.selectedRHCoverage.value
            ].sum_assured;
            benefitRHCost = this.benefitsRH.result[
              this.selectedRHCoverage.value
            ].costo;
            unitCostRHPlanA = this.benefitsRH.result[
              this.selectedRHCoverage.value
            ].costo_plan_a;
            unitCostRHPlanB = this.benefitsRH.result[
              this.selectedRHCoverage.value
            ].costo_plan_b;
            unitCostRHRoundedPlanA = this.benefitsRH.result[
              this.selectedRHCoverage.value
            ].costo_redondeado_plan_a;
            unitCostRHRoundedPlanB = this.benefitsRH.result[
              this.selectedRHCoverage.value
            ].costo_redondeado_plan_b;

            benefitsRHArray.push({
              benefits: { name: benefitRHText, sum_assured: benefitRHValue },
              plan_a: benefitRHPlanA,
              plan_b: benefitRHPlanB,
              sum_assured: benefitRHSumAssuredTotal,
              cost: benefitRHCost,
              unit_cost_plan_a: Number(unitCostRHPlanA).toFixed(2),
              unit_cost_plan_b: Number(unitCostRHPlanB).toFixed(2),
              unit_cost_plan_a_rounded: Number(unitCostRHRoundedPlanA).toFixed(
                2
              ),
              unit_cost_plan_b_rounded: Number(unitCostRHRoundedPlanB).toFixed(
                2
              ),
              unit_cost_plan_a_prorated: this.protated_cost_plan_a_RH,
              unit_cost_plan_b_prorated: this.protated_cost_plan_b_RH,
              admin_cost_plan_a: this.admin_cost_plan_a_RH,
              admin_cost_plan_b: this.admin_cost_plan_b_RH,
            });
          }
          quoteRH = {
            cost: this.valueRH,
            age: this.age,
            product_name: "Respaldo Hospitalario",
            referenced: this.reference,
            benefits: benefitsRHArray,
            product_id: 3,
            client_id: this.client_id,
            bussines_id: this.section,
          };
          this.finalJSON.push(quoteRH);
        }
      }
      // IE
      //var valueIE = 0;
      var benefitsIEArray = [];
      var benefitIEText;
      var benefitIEValue;
      var benefitIEPlanA;
      var benefitIEPlanB;
      var benefitIESumAssuredTotal;
      var benefitIECost;
      var quoteIE;
      var unitCostIEPlanA;
      var unitCostIEPlanB;
      var unitCostIERoundedPlanA;
      var unitCostIERoundedPlanB;

      if (this.selectedIECoverage != null) {
        if (this.selectedIECoverage.value >= 0) {
          /*valueIE = Number(
            this.benefitsIE.result[this.selectedIECoverage.value].costo_total
          );*/

          for (
            let i = 0;
            i <
            this.benefitsIE.result[this.selectedIECoverage.value].benefits
              .length;
            i++
          ) {
            benefitIEText = this.benefitsIE.result[
              this.selectedIECoverage.value
            ].benefits[i].name;
            benefitIEValue = this.benefitsIE.result[
              this.selectedIECoverage.value
            ].benefits[i].sum_assured;
            benefitIEPlanA = this.benefitsIE.result[
              this.selectedIECoverage.value
            ].plan_a_number;
            benefitIEPlanB = this.benefitsIE.result[
              this.selectedIECoverage.value
            ].plan_b_number;
            benefitIESumAssuredTotal = this.benefitsIE.result[
              this.selectedIECoverage.value
            ].sum_assured;
            benefitIECost = this.benefitsIE.result[
              this.selectedIECoverage.value
            ].costo;
            unitCostIEPlanA = this.benefitsIE.result[
              this.selectedIECoverage.value
            ].costo_plan_a;
            unitCostIEPlanB = this.benefitsIE.result[
              this.selectedIECoverage.value
            ].costo_plan_b;
            unitCostIERoundedPlanA = this.benefitsIE.result[
              this.selectedIECoverage.value
            ].costo_redondeado_plan_a;
            unitCostIERoundedPlanB = this.benefitsIE.result[
              this.selectedIECoverage.value
            ].costo_redondeado_plan_b;

            benefitsIEArray.push({
              benefits: { name: benefitIEText, sum_assured: benefitIEValue },
              plan_a: benefitIEPlanA,
              plan_b: benefitIEPlanB,
              sum_assured: benefitIESumAssuredTotal,
              cost: benefitIECost,
              unit_cost_plan_a: Number(unitCostIEPlanA).toFixed(2),
              unit_cost_plan_b: Number(unitCostIEPlanB).toFixed(2),
              unit_cost_plan_a_rounded: Number(unitCostIERoundedPlanA).toFixed(
                2
              ),
              unit_cost_plan_b_rounded: Number(unitCostIERoundedPlanB).toFixed(
                2
              ),
              unit_cost_plan_a_prorated: this.protated_cost_plan_a_IE,
              unit_cost_plan_b_prorated: this.protated_cost_plan_b_IE,
              admin_cost_plan_a: this.admin_cost_plan_a_IE,
              admin_cost_plan_b: this.admin_cost_plan_b_IE,
            });
          }
          quoteIE = {
            cost: this.valueIE,
            age: this.age,
            product_name: "Indemnización por Enfermedades Graves",
            referenced: this.reference,
            benefits: benefitsIEArray,
            product_id: 4,
            client_id: this.client_id,
            bussines_id: this.section,
          };
          this.finalJSON.push(quoteIE);
        }
      }

      // PI
      //var valuePI = 0;
      var benefitsPIArray = [];
      var benefitPIText;
      var benefitPIValue;
      var benefitPIPlanA;
      var benefitPIPlanB;
      var benefitPISumAssuredTotal;
      var benefitPICost;
      var quotePI;
      var costUnitPIPlanA;
      var costUnitPIPlanB;
      var unitCostPIRoundedPlanA;
      var unitCostPIRoundedPlanB;

      if (this.selectedPICoverage != null) {
        if (this.selectedPICoverage.value >= 0) {
          /*valuePI = Number(
            this.benefitsPI.result[this.selectedPICoverage.value].costo_total
          );*/

          for (
            let i = 0;
            i <
            this.benefitsPI.result[this.selectedPICoverage.value].benefits
              .length;
            i++
          ) {
            benefitPIText = this.benefitsPI.result[
              this.selectedPICoverage.value
            ].benefits[i].name;
            benefitPIValue = this.benefitsPI.result[
              this.selectedPICoverage.value
            ].benefits[i].sum_assured;
            benefitPIPlanA = this.benefitsPI.result[
              this.selectedPICoverage.value
            ].plan_a_number;
            benefitPIPlanB = this.benefitsPI.result[
              this.selectedPICoverage.value
            ].plan_b_number;
            benefitPISumAssuredTotal = this.benefitsPI.result[
              this.selectedPICoverage.value
            ].sum_assured;
            benefitPICost = this.benefitsPI.result[
              this.selectedPICoverage.value
            ].costo;
            costUnitPIPlanA = this.benefitsPI.result[
              this.selectedPICoverage.value
            ].costo_plan_a;
            costUnitPIPlanB = this.benefitsPI.result[
              this.selectedPICoverage.value
            ].costo_plan_b;
            unitCostPIRoundedPlanA = this.benefitsPI.result[
              this.selectedPICoverage.value
            ].costo_redondeado_plan_a;
            unitCostPIRoundedPlanB = this.benefitsPI.result[
              this.selectedPICoverage.value
            ].costo_redondeado_plan_b;

            benefitsPIArray.push({
              benefits: { name: benefitPIText, sum_assured: benefitPIValue },
              plan_a: benefitPIPlanA,
              plan_b: benefitPIPlanB,
              sum_assured: benefitPISumAssuredTotal,
              cost: benefitPICost,
              unit_cost_plan_a: Number(costUnitPIPlanA).toFixed(2),
              unit_cost_plan_b: Number(costUnitPIPlanB).toFixed(2),
              unit_cost_plan_a_rounded: Number(unitCostPIRoundedPlanA).toFixed(
                2
              ),
              unit_cost_plan_b_rounded: Number(unitCostPIRoundedPlanB).toFixed(
                2
              ),
              unit_cost_plan_a_prorated: this.protated_cost_plan_a_PI,
              unit_cost_plan_b_prorated: this.protated_cost_plan_b_PI,
              admin_cost_plan_a: this.admin_cost_plan_a_PI,
              admin_cost_plan_b: this.admin_cost_plan_b_PI,
            });
          }
          quotePI = {
            cost: this.valuePI,
            age: this.age,
            product_name: "Pérdida de ingresos",
            referenced: this.reference,
            benefits: benefitsPIArray,
            product_id: 5,
            client_id: this.client_id,
            bussines_id: this.section,
          };
          this.finalJSON.push(quotePI);
        }
      }
    },
    registerNewQuote() {
      this.makeJSON();
      localStorage.setItem("jsonWithQuotes", JSON.stringify(this.finalJSON));

      if (this.finalJSON.length >= 1) {
        axios
          .post(this.api_lineamagisterialproducts + "/quoter/register", {
            quotes: this.finalJSON,
          })
          .then((response) => {
            this.addBenefitModel(response.data.result);
            /*Swal.fire(
              "Registro exitoso",
              "Se ha registrado la cotización correctamente.",
              "success"
            );*/
            //this.addBenefitModel();
            this.$router.push({ name: "personal-information" });
          })
          .catch((error) => {
            console.log("Se presento un error: ", error);
          });
      } else {
        Swal.fire(
          "Seleccione una cobertura",
          "Debe seleccionar una cobertura para continuar.",
          "info"
        );
      }
    },
    /*getPolicyFromLocalStorage(){
        this.policy = JSON.parse(localStorage.getItem('policy'))
        this.addBenefitModel(this.policy)
     },*/
    addBenefitModel(data) {
      let kinship = localStorage.getItem("kinship");
      this.policy = JSON.parse(localStorage.getItem("policy"));
      let benefits_temp = [];
      let details_temp = [];
      let detail_temp = {};
      data.forEach((cober) => {
        //este forEach accede a cada cobertura
        detail_temp.product_id = cober.product_id;
        detail_temp.quotation_id = cober.id;
        detail_temp.total_cost = cober.cost;
        detail_temp.age = cober.age;
        detail_temp.product_name = cober.product_name;

        cober.benefits.forEach((details) => {
          // detalles de cada cobertura
          detail_temp.plan_a = details.plan_a;
          detail_temp.plan_b = details.plan_b;
          detail_temp.sum_assured = details.sum_assured;
          detail_temp.unit_cost_plan_a = details.unit_cost_plan_a;
          detail_temp.unit_cost_plan_b = details.unit_cost_plan_b;
          detail_temp.unit_cost_plan_a_rounded =
            details.unit_cost_plan_a_rounded;
          detail_temp.unit_cost_plan_b_rounded =
            details.unit_cost_plan_b_rounded;
          detail_temp.unit_cost_plan_a_prorated =
            details.unit_cost_plan_a_prorated;
          detail_temp.unit_cost_plan_b_prorated =
            details.unit_cost_plan_b_prorated;
          detail_temp.admin_cost_plan_a = details.admin_cost_plan_a;
          detail_temp.admin_cost_plan_b = details.admin_cost_plan_b;

          benefits_temp.push(details.benefits);
        });

        detail_temp.benefits = benefits_temp;
        details_temp.push(detail_temp);
        detail_temp = {};
        benefits_temp = [];
      });

      if (this.policy == null) {
        this.policy = emptyPolicy;
      }
      if (kinship == "Titular") {
        this.policy.client.selected_products.details = details_temp;
        this.policy.client.contractor_insured = true;
        localStorage.setItem("policy", JSON.stringify(this.policy));
      } else {
        this.policy.client.contractor_insured = false;
        localStorage.setItem("policy", JSON.stringify(this.policy));
      }
      localStorage.setItem("details_temp", JSON.stringify(details_temp));
    },
    saveInLocalStorage() {},
    calculateProratedCost(rounded_cost) {
      if (this.payment_type == "NÓMINA 22%") {
        //es mensual
        return Number((((rounded_cost * 24) / 22) * 2).toFixed(2));
      } else {
        return Number(((rounded_cost * 24) / 22).toFixed(2));
      }
    },
    calculateAdminCost(protated_cost) {
      let formul = this.formula;
      if (formul != 0) {
        formul = formul?.replaceAll(".round(2)", "");
        formul = formul?.replaceAll("eval", "");
        formul = formul?.replaceAll("'", "");
        formul = formul?.replaceAll("importe", protated_cost);
        formul = Number(eval(formul)).toFixed(2);
        return Number(formul);
      } else {
        return 0;
      }
    },
  },
  computed: {
    getTotalSumAP() {
      if (this.selectedAPCoverage === null) {
        return 0;
      }
      return this.plan_a_number_AP + this.plan_b_number_AP;
    },
    getTotalSumIC() {
      if (this.selectedICCoverage === null) {
        return 0;
      }
      return this.plan_a_number_IC + this.plan_b_number_IC;
    },
    getTotalSumRH() {
      if (this.selectedRHCoverage === null) {
        return 0;
      }
      return this.plan_a_number_RH + this.plan_b_number_RH;
    },
    getTotalSumIE() {
      if (this.selectedIECoverage === null) {
        return 0;
      }
      return this.plan_a_number_IE + this.plan_b_number_IE;
    },
    getTotalSumPI() {
      if (this.selectedPICoverage === null) {
        return 0;
      }
      return this.plan_a_number_PI + this.plan_b_number_PI;
    },
    modulesAvailableDependent() {
      if (this.maximunCoveragesDependent - this.totalModulesDependent <= 0) {
        return 0;
      }
      return this.maximunCoveragesDependent - this.totalModulesDependent;
    },
    modulesAvailableTitular() {
      if (this.maximunCoveragesTitular - this.hiresModulesTitular <= 0) {
        return 0;
      }
      return this.maximunCoveragesTitular - this.hiresModulesTitular;
    },
    showCoveragesDependent(){
      if(this.isCoverageByTitular()){
        return this.modulesAvailableTitular;
      }
      return 1;
    },
    sumAssuredTotal() {
      var sum_assured_total;
      var valueAP = 0;
      var valueIC = 0;
      var valueRH = 0;
      var valueIE = 0;
      var valuePI = 0;

      if (this.selectedAPCoverage != null) {
        if (this.selectedAPCoverage.value >= 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          if (this.selectedAPCoverage.value != null) {
            console.log(
              "this.selectedAPCoverage.value: 2222 ",
              this.selectedAPCoverage
            );
            valueAP = Number(
              this.benefitsAP.result[this.selectedAPCoverage.value].sum_assured
            );
          }
        }
      }

      if (this.selectedICCoverage != null) {
        if (this.selectedICCoverage.value >= 0) {
          if (this.selectedICCoverage.value != null) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            valueIC = Number(
              this.benefitsIC.result[this.selectedICCoverage.value].sum_assured
            );
          }
        }
      }

      if (this.selectedRHCoverage != null) {
        if (this.selectedRHCoverage.value >= 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          valueRH = Number(
            this.benefitsRH.result[this.selectedRHCoverage.value].sum_assured
          );
        }
      }

      if (this.selectedIECoverage != null) {
        if (this.selectedIECoverage.value >= 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          valueIE = Number(
            this.benefitsIE.result[this.selectedIECoverage.value].sum_assured
          );
        }
      }

      if (this.selectedPICoverage != null) {
        if (this.selectedPICoverage.value >= 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          valuePI = Number(
            this.benefitsPI.result[this.selectedPICoverage.value].sum_assured
          );
        }
      }

      sum_assured_total = valueAP + valueIC + valueRH + valueIE + valuePI;

      return sum_assured_total.toFixed(2);
    },
    primaQuincenalHired() {
      var prima_quincenal_total;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.valueAP = 0;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.valueIC = 0;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.valueRH = 0;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.valueIE = 0;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.valuePI = 0;

      //AP*
      if (this.selectedAPCoverage != null) {
        if (this.selectedAPCoverage.value >= 0) {
           // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.protated_cost_plan_a_AP = 0;
           // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.protated_cost_plan_b_AP = 0;
           // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.admin_cost_plan_a_AP = 0;
           // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.admin_cost_plan_b_AP = 0;

          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.plan_a_number_AP = this.benefitsAP.result[
            this.selectedAPCoverage.value
          ].plan_a_number;
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.plan_b_number_AP = this.benefitsAP.result[
            this.selectedAPCoverage.value
          ].plan_b_number;

          /* console.log("this.plan_a_number_AP: ", this.plan_a_number_AP);
          console.log("this.plan_b_number_AP: ", this.plan_b_number_AP); */

          if (this.plan_a_number_AP > 0) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_a_AP =
              this.calculateProratedCost(
                this.benefitsAP.result[this.selectedAPCoverage.value]
                  .costo_redondeado_plan_a
              ) * this.plan_a_number_AP;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_a_AP = this.calculateAdminCost(
              this.protated_cost_plan_a_AP
            );
          }

          if (this.plan_b_number_AP > 0) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_b_AP =
              this.calculateProratedCost(
                this.benefitsAP.result[this.selectedAPCoverage.value]
                  .costo_redondeado_plan_b
              ) * this.plan_b_number_AP;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_b_AP = this.calculateAdminCost(
              this.protated_cost_plan_b_AP
            );
          }
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.valueAP = Number(
            this.protated_cost_plan_a_AP +
              this.protated_cost_plan_b_AP +
              this.admin_cost_plan_a_AP +
              this.admin_cost_plan_b_AP
          );
        }
      }
      //IC*
      if (this.selectedICCoverage != null) {
        if (this.selectedICCoverage.value >= 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.protated_cost_plan_a_IC = 0;
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_b_IC = 0;
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_b_IC = 0
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
           this.admin_cost_plan_a_IC = 0;
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.plan_a_number_IC = this.benefitsIC.result[
            this.selectedICCoverage.value
          ].plan_a_number;

          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.plan_b_number_IC = this.benefitsIC.result[
            this.selectedICCoverage.value
          ].plan_b_number;

          if (this.plan_a_number_IC > 0) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_a_IC =
              this.calculateProratedCost(
                this.benefitsIC.result[this.selectedICCoverage.value]
                  .costo_redondeado_plan_a
              ) * this.plan_a_number_IC;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_a_IC = this.calculateAdminCost(
              this.protated_cost_plan_a_IC
            );
          }
          if (this.plan_b_number_IC > 0) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_b_IC =
              this.calculateProratedCost(
                this.benefitsIC.result[this.selectedICCoverage.value]
                  .costo_redondeado_plan_b
              ) * this.plan_b_number_IC;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_b_IC = this.calculateAdminCost(
              this.protated_cost_plan_b_IC
            );
          }

          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.valueIC = Number(
            this.protated_cost_plan_a_IC +
              this.protated_cost_plan_b_IC +
              this.admin_cost_plan_a_IC +
              this.admin_cost_plan_b_IC
          );
        }
      }
      //RH*
      if (this.selectedRHCoverage != null) {
        if (this.selectedRHCoverage.value >= 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_a_RH = 0;
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_b_RH = 0;
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_a_RH = 0;
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_b_RH = 0;
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.plan_a_number_RH = this.benefitsRH.result[
            this.selectedRHCoverage.value
          ].plan_a_number;

          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.plan_b_number_RH = this.benefitsRH.result[
            this.selectedRHCoverage.value
          ].plan_b_number;

          if (this.plan_a_number_RH > 0) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_a_RH =
              this.calculateProratedCost(
                this.benefitsRH.result[this.selectedRHCoverage.value]
                  .costo_redondeado_plan_a
              ) * this.plan_a_number_RH;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_a_RH = this.calculateAdminCost(
              this.protated_cost_plan_a_RH
            );
          }
          if (this.plan_b_number_RH > 0) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_b_RH =
              this.calculateProratedCost(
                this.benefitsRH.result[this.selectedRHCoverage.value]
                  .costo_redondeado_plan_b
              ) * this.plan_b_number_RH;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_b_RH = this.calculateAdminCost(
              this.protated_cost_plan_b_RH
            );
          }

          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.valueRH = Number(
            this.protated_cost_plan_a_RH +
              this.protated_cost_plan_b_RH +
              this.admin_cost_plan_a_RH +
              this.admin_cost_plan_b_RH
          );
        }
      }
      //IE*
      if (this.selectedIECoverage != null) {
        if (this.selectedIECoverage.value >= 0) {
           
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_a_IE = 0;
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.protated_cost_plan_b_IE = 0;
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.admin_cost_plan_a_IE = 0;
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.admin_cost_plan_b_IE = 0;
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.plan_a_number_IE = this.benefitsIE.result[
            this.selectedIECoverage.value
          ].plan_a_number;

          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.plan_b_number_IE = this.benefitsIE.result[
            this.selectedIECoverage.value
          ].plan_b_number;

          if (this.plan_a_number_IE > 0) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_a_IE =
              this.calculateProratedCost(
                this.benefitsIE.result[this.selectedIECoverage.value]
                  .costo_redondeado_plan_a
              ) * this.plan_a_number_IE;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_a_IE = this.calculateAdminCost(
              this.protated_cost_plan_a_IE
            );
          }

          if (this.plan_b_number_IE > 0) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_b_IE =
              this.calculateProratedCost(
                this.benefitsIE.result[this.selectedIECoverage.value]
                  .costo_redondeado_plan_b
              ) * this.plan_b_number_IE;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_b_IE = this.calculateAdminCost(
              this.protated_cost_plan_b_IE
            );
          }

          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.valueIE = Number(
            this.protated_cost_plan_a_IE +
              this.protated_cost_plan_b_IE +
              this.admin_cost_plan_a_IE +
              this.admin_cost_plan_b_IE
          );
        }
      }
      //PI*
      if (this.selectedPICoverage != null) {
        if (this.selectedPICoverage.value >= 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_a_PI = 0;
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.protated_cost_plan_b_PI = 0;
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.admin_cost_plan_a_PI = 0;
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.admin_cost_plan_b_PI = 0;
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.plan_a_number_PI = this.benefitsPI.result[
            this.selectedPICoverage.value
          ].plan_a_number;

          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.plan_b_number_PI = this.benefitsPI.result[
            this.selectedPICoverage.value
          ].plan_b_number;

          if (this.plan_a_number_PI > 0) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_a_PI =
              this.calculateProratedCost(
                this.benefitsPI.result[this.selectedPICoverage.value]
                  .costo_redondeado_plan_a
              ) * this.plan_a_number_PI;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_a_PI = this.calculateAdminCost(
              this.protated_cost_plan_a_PI
            );
          }

          if (this.plan_b_number_PI > 0) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_b_PI =
              this.calculateProratedCost(
                this.benefitsPI.result[this.selectedPICoverage.value]
                  .costo_redondeado_plan_b
              ) * this.plan_b_number_PI;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_b_PI = this.calculateAdminCost(
              this.protated_cost_plan_b_PI
            );
          }

          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.valuePI = Number(
            this.protated_cost_plan_a_PI +
              this.protated_cost_plan_b_PI +
              this.admin_cost_plan_a_PI +
              this.admin_cost_plan_b_PI
          );
        }
      }

      prima_quincenal_total =
        this.valueAP +
        this.valueIC +
        this.valueRH +
        this.valueIE +
        this.valuePI;
      if (this.isCoverageByTitular()) {
        if (!this.getTotalModulesByCoverage(this.moduleSelected)) {
          this.showAlertMaximunCoverageReached(
            this.getCoverageNameByNomenclature(this.moduleSelected)
          );
          this.setSelectedValueToNull();
        }
        if (!this.calculateAvailableModules()) {
          this.showAlertMaximunModulesReached();
          this.setSelectedValueToNull();
        }
      }

      return prima_quincenal_total;
    },
    selectAPOptions() {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });
      if (this.benefitsAP != undefined) {
        return this.benefitsAP.result?.map((coverageAP) => ({
          label: formatter.format(coverageAP.sum_assured),
          value: coverageAP.positionArray,
        }));
      } else {
        return false;
      }
    },
    selectICOptions() {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });
      return this.benefitsIC.result?.map((coverageIC) => ({
        label: formatter.format(coverageIC.sum_assured),
        value: coverageIC.positionArray,
      }));
    },
    selectRHOptions() {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });
      return this.benefitsRH.result?.map((coverageRH) => ({
        label: formatter.format(coverageRH.sum_assured),
        value: coverageRH.positionArray,
      }));
    },
    selectIEOptions() {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });
      return this.benefitsIE.result?.map((coverageIE) => ({
        label: formatter.format(coverageIE.sum_assured),
        value: coverageIE.positionArray,
      }));
    },
    selectPIOptions() {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });
      return this.benefitsPI.result?.map((coveragePI) => ({
        label: formatter.format(coveragePI.sum_assured),
        value: coveragePI.positionArray,
      }));
    },
  },
};
</script>

<style scoped>
.controls > button:not(.active) {
  transform: scale(0.8);
}
.box-shadow {
  border: 1px;
  padding: 10px;
  box-shadow: 2px 10px 8px #888888;
}
</style>
